const functions = {
    createCustomer: 'api-accounts-createCustomer',
    getNearestStore: 'api-store-nearByStore',
    nearByStores: 'api-store-nearByStores',
    updateCustomer: 'api-accounts-updateCustomer',
    deleteCustomer: 'api-accounts-deleteCustomer',
    sendOtp: 'api-accounts-sendOtp',
    verifyOtp: 'api-accounts-verifyOtp',
};

export default functions;
